import { addDoc, collection } from "firebase/firestore";
import { useNavigate } from "react-router";
import { db } from "../Firebase/firebase";
import moment from "moment";

const useContactSeller = (realTimeData, userId, chatRoomsArr) => {
  const navigate = useNavigate();

  const contactSeller = async (
    e,
    prodId,
    sellerId,
    sellerName,
    firstMessage,
    disableForm,
  ) => {
    e.preventDefault();
    console.log(firstMessage);
    if (userId === sellerId) {
      console.log("you can't sell stuff to yourself");
    } else {
      try {
        await addDoc(collection(db, "chats"), {
          chat: [],
          clientId: userId,
          sellerId,
          clientName: realTimeData?.displayName,
          sellerName,
          soldProductId: prodId,
          firstMessage,
          chatEnabled: false,
          chatCreatedAt: moment().format("DD.MM.YYYY/hh:mm"),
        });
        disableForm();
        window.location.reload();
        console.log("created new room");
      } catch (error) {
        console.log(error, "can't send message");
      }
    }
  };

  // console.log(chatRoomsArr)

  const chatRoomObject = (prodId, sellerId) => {
    const chatRoom = chatRoomsArr
      ?.filter(
        (item) =>
          item.soldProductId === prodId &&
          item.sellerId === sellerId &&
          item.clientId === userId
      )
      .map((item) => {
        return {
          chatRoomId: item.chatRoomId,
          isChatRoomEnabled: item.chatEnabled,
        };
      })
      .shift();
    return chatRoom;
  };

  return { contactSeller, chatRoomObject };
};

export default useContactSeller;
